import ModelUpdate from "@/models/ModelUpdate";
import {ValidationRule} from "@/declarations/ValidationRule";
import OrderRules from "@/models/order/OrderRules";
import Order from "@/models/order/Order";

export default class OrderUpdate extends ModelUpdate<Order> {

	public name!: string | null;
	public dateFrom!: string | null;
	public dateTo!: string | null;
	public hourlyRate!: number | null;
	public dailyLumpSum!: number | null;
	public notes!: string | null;

	protected initializeWithDetailModelData(detailModel: Order): void {
		this.name = detailModel.name;
		this.dateFrom = detailModel.dateFrom;
		this.dateTo = detailModel.dateTo;
		this.hourlyRate = detailModel.hourlyRate;
		this.dailyLumpSum = detailModel.dailyLumpSum;
		this.notes = detailModel.notes;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'name':
				return OrderRules.nameRules;
			case 'dateFrom':
				return OrderRules.dateFromRules;
			case 'dateTo':
				return OrderRules.dateToRules;
			case 'hourlyRate':
				return OrderRules.hourlyRateRules;
			case 'dailyLumpSum':
				return OrderRules.dailyLumpSumRules;
			default:
				return [];
		}
	}

}
